import { WGCWX_INVENTORY_STYLES_SUCCESS } from 'state/actions/wgcwx_shop'

const initialState = {
    styles: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case WGCWX_INVENTORY_STYLES_SUCCESS:
        return {
            ...state,
            styles: action.payload.styles,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/inventory_styles.js